<mat-card-header class="nsc-card-title-error">
    <mat-card-title>
      <h3>
        <span aria-hidden="true" class="col-auto icon_style" *ngIf="icon">
          <mat-icon>{{icon}}</mat-icon>            
        </span>
        {{title}}</h3>
    </mat-card-title>
  </mat-card-header>